import HashStraight from '@components/Icons/HashStraight';
import * as ApiModels from '@typings/api-models';
import BaseAnswer from './BaseAnswer';
import s from '../QuestionAndAnswer.module.scss';

type Props = {
  field: ApiModels.FormResponseIntegerField;
};

const IntegerAnswer: React.FC<Props> = ({ field: { answer } }) => (
  <div className={s.answer}><HashStraight weight='regular' /><BaseAnswer answer={answer === null ? null : answer.toFixed(0)} /></div>
);

export default IntegerAnswer;
